import { apiFetch } from "@/lib/api";

export interface SalesOrderShipByCalendarLoadResponse {
  serializedUnitsByDate: Record<string, number>;
}

export async function fetchSalesOrderShipByCalendarLoad(
  fromInclusiveIso: string,
  toInclusiveIso: string,
): Promise<SalesOrderShipByCalendarLoadResponse> {
  return apiFetch<SalesOrderShipByCalendarLoadResponse>("/api/sales-orders/ship-by-calendar-load", {
    query: {
      from: fromInclusiveIso,
      to: toInclusiveIso,
    },
  });
}

/** One request for every open serialized ship-by date; month navigation uses this map client-side. */
export async function fetchSalesOrderShipByCalendarFullSchedule(): Promise<SalesOrderShipByCalendarLoadResponse> {
  return apiFetch<SalesOrderShipByCalendarLoadResponse>("/api/sales-orders/ship-by-calendar-load", {
    query: {
      scope: "full",
    },
  });
}
